import {Injectable} from '@angular/core';
import {CanDeactivate} from '@angular/router';
import {Observable} from 'rxjs';
import {NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import {ModalSaveComponent} from './../components/modal-save/modal-save.component';

export interface CanComponentDeactivate {
    canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class GuardDraftGuard extends ModalSaveComponent implements CanDeactivate<CanComponentDeactivate> {

    canDeactivate() {
        const options: NgbModalOptions = {
            backdrop: 'static',
            size: 'lg',
            centered: true,
            windowClass: 'modalAlertChange'

        };

        if (this.orderId !== null && this.orderCompleted === false) {
            this.modalService.open(ModalSaveComponent, options);

            return this.draftService.navigateAwaySelection$;
        }

        return true;
    }
}
